module.exports = __webpack_public_path__ + "img/SaintsCameMarchingInFB.02ee7b32.02ee7b32.gif";